// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09aa4343","455":"d3d44502","977":"518eecde"}[chunkId] + ".chunk.js";
};